<template>
  <div ref="editorRef" style="width: 100%;height: 500px;"></div>
  <ResourceModal ref="resourceModalRef" @ok="onChoosed" />
</template>

<script lang="ts" setup>
import ResourceModal from '@/components/resource/ResourceModal.vue'
import { ResourceChoosedType } from '@/models/types'
import { markRaw, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const editorRef = ref()
const resourceModalRef = ref()
const quillEditor = ref()
const _content = ref('')

// eslint-disable-next-line no-undef
const emit = defineEmits(['change'])
// eslint-disable-next-line no-undef
const props = defineProps({
  content: String
})
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],
  [{ 'indent': '-1' }, { 'indent': '+1' }],
  [{ 'direction': 'rtl' }],
  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],
  [{ 'font': [] }],
  [{ 'align': [] }],
  ['clean'],
  ['link', 'image', 'video']
]

const initEditor = () => {
  const quill = new Quill(editorRef.value, {
    modules: {
      toolbar: toolbarOptions
    },
    theme: 'snow'
  })

  quill.on('text-change', () => {
    const content = quill.getSemanticHTML()

    _content.value = content
    emit('change', content)
  })


  console.log('初始化编辑器')
  quillEditor.value = markRaw(quill)
}

const onChoosed = (e: ResourceChoosedType) => {
  console.log(e)
}

watch(
  () => props.content,
  (newVal) => {
    if (quillEditor.value) {
      if (newVal && newVal !== _content.value) {
        _content.value = newVal
        quillEditor.value.clipboard.dangerouslyPasteHTML(newVal)
      } else if (!newVal) {
        quillEditor.value.setText('')
      }
    }
  }
)

onMounted(() => {
  nextTick(() => {
    initEditor()
  })
})

onUnmounted(() => {
  quillEditor.value = null
  delete quillEditor.value
})
</script>